__turbopack_context__.v({
  "container": "FullBodyUpload-module-scss-module__bpojXa__container",
  "imageContainer": "FullBodyUpload-module-scss-module__bpojXa__imageContainer",
});
